import {FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {OrdersService} from '../../../services/orders.service';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {AfterViewInit, Component, OnInit} from '@angular/core';

/**------------------------------------------------------
 * Component for EXTRA FEE MODAL Window
 *------------------------------------------------------*/

@Component({
  selector: 'extra-fees-dialog',
  template: `
        <div class="modal-content">
            <div class="modal-title bg-success">
                <h3>Add extra charge</h3>
            </div>
            <div class="modal-body">
                <form [formGroup]="extraFeesForm" (change)="countTotals();" (keydown.enter)="$event.preventDefault()" >
                    <div formArrayName="extraFees">
                        <div class="row row--space-between" style="display: flex;">
                            <div class="row__input" style="width: 20%;">Description</div>
                            <div class="row__input" style="width: 20%;">Amount</div>
                            <div class="row__input" style="width: 20%;">VAT(%)</div>
                            <div class="row__input" style="width: 20%;">VAT</div>
                            <div class="row__input" style="width: 20%;">Total</div>
                        </div>
                        <div class="extra-fee row"
                             *ngFor="let fee of extraFeesForm.get('extraFees')['controls']; let i=index"
                        >
                            <extra-fee
                            style="width: 100%;"
                            [group]="fee"
                            [count]="i"></extra-fee>
                        </div>
                    </div>

                    <div class="row row--space-between" style="margin-top: 20px;">
                        <div>
                            <button mat-raised-button class="btn-small" color="primary" (click)="addFee()" ><mat-icon>add</mat-icon></button>
                        </div>
                        <div>
                            <b>VAT: {{totalVats}}</b>
                        </div>
                        <div>
                            <b>Total: {{totalFees}}</b>
                        </div>
                    </div>

                </form>
            </div>

            <mat-dialog-actions align="end">
                <button mat-button class="left" (click)="closeModal()">Cancel</button>
                <button mat-raised-button color="success" class="right" *ngIf="!disableAddCharge" (click)="submitExtraFees()" [disabled]="submitted">Save</button>
                <button mat-raised-button color="success" class="right" *ngIf="disableAddCharge" (click)="closeModal()">OK</button>
            </mat-dialog-actions>
        </div>
    `,
})
export class ExtraFeesDialogComponent implements OnInit, AfterViewInit {
  orderId: any;
  shipmentId: any;
  oldEtraCharges: any;
  disableAddCharge = false;
  showFormError = true;
  submitted = false;
  extraFeesForm: FormGroup;
  totalVats = '0.00';
  totalFees = '0.00';

  openWindow(href) {
    window.open(href, '');
    return false;
  }

  constructor(public dialogRef: MatDialogRef<ExtraFeesDialogComponent>,
              private _fb: FormBuilder,
              private orderService: OrdersService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar) {
    this.extraFeesForm = this._fb.group({
      extraFees: this._fb.array([
        //this.initExtraFee({vatPercent: 25})
      ])
    });
  }

  ngAfterViewInit() {
  }
  closeModal() {
    this.dialogRef.close('Yes!');
  }

  ngOnInit() {
    if (this.oldEtraCharges.length > 0) {
      this.disableAddCharge = true;
      const payments = this.oldEtraCharges;
      for (const i in payments) {
        if (payments[i].status !== 0) {
          const items = payments[i].extra_charges;
          for (const j in items) {
            this.extraFeesForm.controls['extraFees']['controls'].push(
              this.initExtraFee({
                description: items[j].description,
                amount:      items[j].amount,
                vatPercent:  Number(items[j].vat_percent),
                vatValue:    items[j].vat,
                total:       items[j].total
              })
            );
          }
        }
      }
      if (this.extraFeesForm.controls['extraFees']['controls'].length > 0) {
        this.countTotals();
      } else {
        const feesControl = this.extraFeesForm.controls['extraFees']['controls'] as FormArray;
        feesControl.push(this.initExtraFee({vatPercent: 25}));
        this.disableAddCharge = false;
      }
    } else {
      const feesControl = this.extraFeesForm.controls['extraFees']['controls'] as FormArray;
      feesControl.push(this.initExtraFee({vatPercent: 25}));
    }
  }

  initExtraFee(values: any = {}): FormGroup {
    const val = {
      description: '',
      amount: '0',
      vatPercent: '0',
      vatValue: '0',
      total: '0'
    };
    let dsbl = false;
    if (Object.keys(values).length > 0) {
      if (parseFloat(values['amount']) > 0) {
        dsbl = true;
      }
      for (const i in values) {
        if (val[i] !== undefined) {
          val[i] = values[i];
        }
      }
    }
    return this._fb.group({
      description: [{value: val.description, disabled: dsbl}, Validators.required],
      amount: [{value: parseInt(val.amount), disabled: dsbl}, [Validators.required, this.validateAmount]],
      vatPercent: [{value: val.vatPercent, disabled: dsbl}, [Validators.required, this.validateVat]],
      vatValue: [{value: val.vatValue, disabled: true}, Validators.required],
      total: [{value: val.total, disabled: true}, Validators.required]
    });
  }

  validateAmount(control: FormControl) {
    return parseFloat(control.value) > 0 ? null : {
      min: true
    };
  }
  validateVat(control: FormControl) {
    return parseInt(control.value) > 0 && parseInt(control.value) <= 100 ? null : {
      minMax: true
    };
  }

  static maxNum(max: number): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {

      const val: number = control.value;

      if (control.pristine || control.pristine) {
        return null;
      }
      if (val <= max) {
        return null;
      }
      return { 'max': true };
    };
  }
  static minNum(min: number): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {

      const val: number = control.value;

      if (control.pristine || control.pristine) {
        return null;
      }
      if (val >= min) {
        return null;
      }
      return { 'min': true };
    };
  }


  addFee() {
    //const control = <FormArray>this.extraFeesForm.controls['extraFees'];
    //control.push(this.initExtraFee({vatPercent: 25}));

    this.extraFeesForm.controls['extraFees']['controls'].push(
      this.initExtraFee({vatPercent: 25})
    );
    this.disableAddCharge = false;
  }

  countTotals() {
    const allFees = this.extraFeesForm.controls['extraFees']['controls'];
    let newTotalVats = 0;
    let newTotalFees = 0;
    for (const i in allFees) {
      const itemVat = allFees[i]['controls'].vatValue.value;
      const itemTotal = allFees[i]['controls'].total.value;
      newTotalVats += parseFloat(itemVat);
      newTotalFees += parseFloat(itemTotal);
    }
    this.totalVats = Number(newTotalVats).toFixed(2);
    this.totalFees = Number(newTotalFees).toFixed(2);
  }

  correctFloat(val) {
    let result;
    if (typeof val === 'string') {
      result = Number(val.replace(/,/g , '.')).toFixed(2);
    } else {
      result = Number(parseFloat(val)).toFixed(2);
    }
    return parseFloat(result);
  }


  submitExtraFees() {
    const charges: any = [];
    const extrafees = this.extraFeesForm.controls['extraFees']['controls'];
    for (const i in extrafees) {
      if (extrafees[i].valid) {
        const amount = this.correctFloat(extrafees[i].value.amount);
        const vat = this.correctFloat(extrafees[i].value.vatPercent);
        charges.push({
          'description': extrafees[i].value.description,
          'amount': amount,
          'vat': vat
        });
      }
    }
    if (charges.length > 0) {
      const data: any = {
        'shipment_id': this.shipmentId,
        'charges': charges
      };

      this.submitted = true;
      const self = this;
      this.orderService.setExtraCharge(this.orderId, data).subscribe(
        data => {
          // if (data.message == 'success') {
          //     this.dialogRef.close('update');
          //     this.snackBar.open('Extra charge added successfully','', {
          //         duration: 2000,
          //     });
          // }
        },
        error => {
          console.log(error);
          self.dialogRef.close('update');
        }
      );
    } else {
      if (this.showFormError) {
        this.showFormError = false;
        this.snackBar.open('Please, check all fields!', '', {
          duration: 2000,
        });
        setInterval (() => {
          this.showFormError = true;
        }, 3000);
      }


    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/extra-fees/extra-fees.component.ts